<owc-breadcrumb #breadcrumbElement class="custom-breadcrumb">
    <owc-breadcrumb-item 
        [routerLink]="['/']" 
        [hyperlinkProps]="{target:'_self'}" 
        data-testid="breadcrumb-dashboard-link"
        (click)="$event.preventDefault();">
            <owc-typography  variant="badge">
                {{dashboard}}
            </owc-typography>
    </owc-breadcrumb-item>
    <owc-breadcrumb-item 
        *ngFor="let breadcrumb of breadcrumbs; let index = index,let last = last;" 
        [url]="breadcrumb.url"
        [hyperlinkProps]="{target:'_self'}" 
        [attr.data-testid]="'breadcrumb-navigate-' + getAutomationKey(breadcrumb.label, index)"
        (click)="$event.preventDefault();navigate(breadcrumb);" >
        <span *ngIf="!last"> 
            <owc-typography variant="badge">
                {{breadcrumb.label}}
            </owc-typography>
        </span>
        <span *ngIf="last"> 
            <owc-typography variant="caption">
                 {{ breadcrumb.label.length > 50 ? ((breadcrumb.label | slice:0:47) +'...') : breadcrumb.label }}
            </owc-typography>
        </span>
    </owc-breadcrumb-item>
</owc-breadcrumb>